import { StorePaymentLogGetRequestCategoryOfPlanEnum } from "../api/main";
import { Plan } from "../store/slice/logSlice";

export const paymentPlanEnumConverter = (order: Plan):  StorePaymentLogGetRequestCategoryOfPlanEnum => {
  switch (order) {
    case 'subscribe': return  StorePaymentLogGetRequestCategoryOfPlanEnum.Subscribe;
    case 'temporaryUse': return  StorePaymentLogGetRequestCategoryOfPlanEnum.TemporaryUse;
    default: return  StorePaymentLogGetRequestCategoryOfPlanEnum.Subscribe;
  }
}